import { NavLink } from "react-router-dom";
import { FileText, Newspaper, Mail, Radio, Bot, Inbox } from "lucide-react";

const tabs = [
  { to: "/admin/filings", label: "Filings", icon: FileText, testId: "admin-tab-filings" },
  { to: "/admin/drafts", label: "Drafts", icon: Newspaper, testId: "admin-tab-drafts" },
  { to: "/admin/press-releases", label: "Press Releases", icon: Radio, testId: "admin-tab-press-releases" },
  { to: "/admin/submissions", label: "Submissions", icon: Inbox, testId: "admin-tab-submissions" },
  { to: "/admin/agent-keys", label: "Agent Keys", icon: Bot, testId: "admin-tab-agent-keys" },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail, testId: "admin-tab-newsletter" },
];

export default function AdminTabs() {
  return (
    <nav data-testid="admin-tabs" className="bb-container flex gap-1 border-b border-border overflow-x-auto -mx-0">
      {tabs.map(({ to, label, icon: Icon, testId }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={testId}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 px-4 py-3 text-[11px] font-archivo uppercase tracking-widest border-b-2 min-h-[44px] transition-colors ${
              isActive
                ? "border-bb-copper text-bb-navy"
                : "border-transparent text-bb-slate hover:text-bb-navy"
            }`
          }
          end
        >
          <Icon size={13} /> {label}
        </NavLink>
      ))}
    </nav>
  );
}
